import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateTeam } from "../ApiProvider";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { TeamForm } from "./TeamForm";
export const CreateTeam = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const navigate = useNavigate();
    const onSuccess = (data) => {
        const team = data.data;
        navigate(`/teams/${team.id}/`);
    };
    const onError = (error) => {
        setLoading(false);
        setError(error);
    };
    const mutation = useCreateTeam({
        onMutate: () => setLoading(true),
        onSuccess,
        onError,
    });
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!error, message: "Failed to create team. Please try again.", onClose: () => setError(undefined) }), _jsx(Typography, { variant: "h4", gutterBottom: true, sx: { fontSize: { xs: "1.75rem", sm: "2.125rem" } }, children: "Create Team" }), _jsx(TeamForm, { onSubmit: mutation.mutate })] }));
};
